export default {
  option: {},
  beneficiariesUserInfo: {},
  beneficiaries: [{ id: 0, nombres_apellidos: '', porcentaje_asignado: '', posicionHogar: '' }],
  taker: {
    tipo_documento: 'CC',
    state: '',
    city: '',
    genero: 'M',
    estadoCivil: ''
  },
  plan: {}
}
